type ShortCircuitLedger = Record<string, number>;

/**
 * Track URLs which we want to limit the number of retries until the signage
 * restarts
 */
const shortCircuitLedger: ShortCircuitLedger = {};

/**
 * Registers a URL to have a maximum retry of maximumAttempts retries until the
 * signage restarts. This will be respected regardless of if the DOM element is
 * deleted and re-added.
 */
export function registerShortCircuitUrl(urlToShortCircuit: string, maximumAttempts: number): void {
    if (shortCircuitLedger[urlToShortCircuit]) {
        return;
    }

    shortCircuitLedger[urlToShortCircuit] = maximumAttempts;
}

/**
 * Check if a URL has an entry in the Short Circuit Ledger.
 */
export function inLedger(url: string): boolean {
    return typeof shortCircuitLedger[url] !== 'undefined';
}

/**
 * Has the URL hit its max retry count and no further download attempts will be
 * made.
 */
export function hasHitMaxAttempts(url: string): boolean {
    return inLedger(url) && shortCircuitLedger[url] < 1;
}

/**
 * Add an retry attempt to the given URL.
 */
export function trackAttempt(url: string): void {
    if (!hasHitMaxAttempts(url)) {
        --shortCircuitLedger[url];
    }
}

export function getLedger(): ShortCircuitLedger {
    return shortCircuitLedger;
}
